


import React, { useEffect, useState } from "react";
import axios from "axios";

import {
  GoogleMap,
  Marker,
  LoadScript,
} from "@react-google-maps/api";

/* =========================
    MAP STYLE
========================= */

const mapContainerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "10px",
};

const Employee = () => {

  /* =========================
      STATES
  ========================= */

  const [employeeName, setEmployeeName] =
    useState("");

  const [mobile, setMobile] =
    useState("");

  const [
    assignedDepartmentId,
    setAssignedDepartmentId,
  ] = useState("");

  const [latitude, setLatitude] =
    useState("");

  const [longitude, setLongitude] =
    useState("");

  const [departments, setDepartments] =
    useState([]);

  const [employees, setEmployees] =
    useState([]);

  const [showForm, setShowForm] =
    useState(false);

  const [position, setPosition] =
    useState({
      lat: 17.3850,
      lng: 78.4867,
    });

  const [mapRef, setMapRef] =
    useState(null);

  /* =========================
      GOOGLE MAP API KEY
  ========================= */

  const GOOGLE_MAP_KEY =
    "AIzaSyAmGcPTfePx1WqX-8bqlPno6-5hU_GE9uA";



  /* =========================
      FETCH DEPARTMENTS
  ========================= */

  const fetchDepartments = async () => {

    try {

      const res = await axios.get(
        "https://gpsapi.emedha.in/web/api/department"
      );

      setDepartments(res.data);

    } catch (error) {

      console.log(error);

    }
  };



  /* =========================
      FETCH EMPLOYEES
  ========================= */

  const fetchEmployees = async () => {

    try {

      const res = await axios.get(
        "https://gpsapi.emedha.in/web/api/employee"
      );

      setEmployees(res.data);

    } catch (error) {

      console.log(error);

    }
  };



  useEffect(() => {

    fetchDepartments();

    fetchEmployees();

  }, []);




  /* =========================
      HANDLE DEPARTMENT
  ========================= */

  const handleDepartment = (value) => {

    setAssignedDepartmentId(value);

    const selectedDepartment =
      departments.find(
        (item) => item.id === value
      );

    if (selectedDepartment) {

      setLatitude(
        selectedDepartment.latitude
      );

      setLongitude(
        selectedDepartment.longitude
      );

      setPosition({
        lat: Number(
          selectedDepartment.latitude
        ),
        lng: Number(
          selectedDepartment.longitude
        ),
      });

      if (mapRef) {

        mapRef.panTo({
          lat: Number(
            selectedDepartment.latitude
          ),
          lng: Number(
            selectedDepartment.longitude
          ),
        });

        mapRef.setZoom(16);
      }
    }
  };




  /* =========================
      CREATE EMPLOYEE
  ========================= */

  const handleSubmit = async () => {

    if (
      !employeeName ||
      !mobile ||
      !assignedDepartmentId
    ) {

      alert("Please Fill All Fields");

      return;
    }

    const payload = {

      name: employeeName,

      mobile: mobile,

      assigned_department_id:
        assignedDepartmentId,
    };

    try {

      await axios.post(
        "https://gpsapi.emedha.in/web/api/employee",
        payload
      );

      alert(
        "Employee Created Successfully"
      );



      /* =========================
          CLEAR FORM
      ========================= */

      setEmployeeName("");

      setMobile("");

      setAssignedDepartmentId("");

      setLatitude("");

      setLongitude("");

      setShowForm(false);



      /* =========================
          REFRESH TABLE
      ========================= */

      fetchEmployees();

    } catch (error) {

      console.log(error);

    }
  };




  /* =========================
      DELETE EMPLOYEE
  ========================= */

  const handleDelete = async (id) => {

    try {

      await axios.delete(
        `https://gpsapi.emedha.in/web/api/employee/${id}`
      );

      alert("Deleted Successfully");

      fetchEmployees();

    } catch (error) {

      console.log(error);

    }
  };



  return (

    <div
      style={{
        padding: "20px",
        backgroundColor: "#f4f6f9",
        minHeight: "100vh",
        fontFamily: "Arial",
      }}
    >

      {/* BUTTON */}

      <button
        onClick={() =>
          setShowForm(!showForm)
        }
        style={{
          backgroundColor: showForm
            ? "red"
            : "#007bff",
          color: "#fff",
          border: "none",
          padding: "12px 20px",
          borderRadius: "5px",
          cursor: "pointer",
          fontWeight: "bold",
          fontSize: "15px",
          marginBottom: "20px",
        }}
      >
        {showForm
          ? "Close Form"
          : "Create Employee"}
      </button>



      {/* FORM */}

      {showForm && (

        <div
          style={{
            maxWidth: "900px",
            margin: "auto",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "10px",
            boxShadow:
              "0px 0px 10px rgba(0,0,0,0.1)",
          }}
        >

          <h2
            style={{
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            Employee Screen
          </h2>



          {/* EMPLOYEE NAME */}

          <input
            type="text"
            placeholder="Enter Employee Name"
            value={employeeName}
            onChange={(e) =>
              setEmployeeName(
                e.target.value
              )
            }
            style={inputStyle}
          />



          {/* MOBILE */}

          <input
            type="text"
            placeholder="Enter Mobile Number"
            value={mobile}
            onChange={(e) =>
              setMobile(
                e.target.value
              )
            }
            style={inputStyle}
          />



          {/* DEPARTMENT ID */}

          <select
            value={assignedDepartmentId}
            onChange={(e) =>
              handleDepartment(
                e.target.value
              )
            }
            style={inputStyle}
          >

            <option value="">
              Select Department ID
            </option>

            {departments.map((item) => (

              <option
                key={item.id}
                value={item.id}
              >
                {item.id}
              </option>

            ))}

          </select>



          {/* LATITUDE */}

          <input
            type="text"
            value={latitude}
            disabled
            placeholder="Latitude"
            style={{
              ...inputStyle,
              backgroundColor:
                "#e9ecef",
              cursor: "not-allowed",
            }}
          />



          {/* LONGITUDE */}

          <input
            type="text"
            value={longitude}
            disabled
            placeholder="Longitude"
            style={{
              ...inputStyle,
              backgroundColor:
                "#e9ecef",
              cursor: "not-allowed",
            }}
          />



          {/* GOOGLE MAP */}

          <LoadScript
            googleMapsApiKey={
              GOOGLE_MAP_KEY
            }
          >

            <GoogleMap
              mapContainerStyle={
                mapContainerStyle
              }
              center={position}
              zoom={15}
              onLoad={(map) =>
                setMapRef(map)
              }
            >

              <Marker
                position={position}
              />

            </GoogleMap>

          </LoadScript>



          {/* SUBMIT BUTTON */}

          <button
            onClick={handleSubmit}
            style={{
              width: "100%",
              padding: "14px",
              backgroundColor:
                "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: "16px",
              marginTop: "20px",
            }}
          >
            Create Employee
          </button>

        </div>

      )}



      {/* TABLE */}

      <div
        style={{
          marginTop: "40px",
          overflowX: "auto",
        }}
      >

        <table
          style={{
            width: "100%",
            borderCollapse:
              "collapse",
            backgroundColor: "#fff",
          }}
        >

          <thead>

            <tr
              style={{
                backgroundColor:
                  "#007bff",
                color: "#fff",
              }}
            >

              <th style={tableHead}>
                ID
              </th>

              <th style={tableHead}>
                Employee Name
              </th>

              <th style={tableHead}>
                Mobile
              </th>

              <th style={tableHead}>
                Assigned Department ID
              </th>

              <th style={tableHead}>
                Actions
              </th>

            </tr>

          </thead>

          <tbody>

            {employees.map((item) => (

              <tr key={item.id}>

                <td style={tableCell}>
                  {item.id}
                </td>

                <td style={tableCell}>
                  {item.name}
                </td>

                <td style={tableCell}>
                  {item.mobile}
                </td>

                <td style={tableCell}>
                  {
                    item.assigned_department_id
                  }
                </td>

                <td style={tableCell}>

                  <button
                    onClick={() =>
                      handleDelete(
                        item.id
                      )
                    }
                    style={{
                      backgroundColor:
                        "red",
                      color: "#fff",
                      border: "none",
                      padding:
                        "8px 15px",
                      borderRadius:
                        "5px",
                      cursor:
                        "pointer",
                    }}
                  >
                    Delete
                  </button>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};



/* =========================
    COMMON INPUT STYLE
========================= */

const inputStyle = {
  width: "100%",
  padding: "12px",
  border: "1px solid #ccc",
  borderRadius: "5px",
  marginBottom: "15px",
  outline: "none",
};



/* =========================
    TABLE STYLE
========================= */

const tableHead = {
  border: "1px solid #ddd",
  padding: "12px",
};

const tableCell = {
  border: "1px solid #ddd",
  padding: "12px",
  textAlign: "center",
};

export default Employee;